<!-- 机构设置 -->
<template>
  <div class="basicStyle">
    <div class="bg_box">
      <h1>
        机构信息设置
        <el-popover placement="right" trigger="hover" class="popoverClass">
          <p style="text-align: center; line-height: 40px">
            企业机构信息设置说明：
          </p>
          <p>企业机构信息设置完成后，在APP前台页面将显示相关的信息</p>
          <p>1、机构名称和LOGO将在APP首页显示</p>
          <p>2、联系方式和微信号将在客服联系方式上显示</p>
          <p>3、“关于我们”介绍内容将在个人中心显示</p>
          <p style="margin-top: 15px">
            设置完成成功提交后，管理员审核通过 后，将正式显示在APP上面
          </p>

          <i class="el-icon--right questionIcon" slot="reference"></i>
        </el-popover>
      </h1>
      <el-form
        :model="userInfo"
        :rules="userRules"
        ref="codeInfoForm"
        label-width="200px"
      >
        <el-form-item label="机构名称：">
          <el-input
            v-model="userInfo.name"
            placeholder="请输入机构名称"
            size="mini"
            :disabled="requireStatus"
          ></el-input>
        </el-form-item>
        <el-form-item label="机构logo：">
          <div v-if="requireStatus">
            <el-image
              v-if="userInfo.logo"
              style="width: 226px; height: 88px"
              fit="contain"
              :src="userInfo.logo"
              :preview-src-list="[userInfo.logo]"
            />
            <p style="margin-left: 0; color: grey; font-size: 12px">
              上传jpg或png,尺寸226*88像素
              <el-button type="text" @click="viewingCases()"
                >查看案例</el-button
              >
            </p>
          </div>
          <div v-else>
            <el-upload
              action="#"
              class="avatar-uploader"
              accept="gif,bmp,jpg,jpeg,png"
              :show-file-list="false"
              :multiple="false"
              :auto-upload="false"
              :on-change="
                (file, fileList) => {
                  handleAvatarSuccess(file, fileList, 'logo');
                }
              "
              :disabled="requireStatus"
            >
              <div v-if="userInfo.logo" style="position: relative">
                <img :src="userInfo.logo" />
                <i
                  class="el-icon-error"
                  style="
                    position: absolute;
                    right: -15px;
                    top: -15px;
                    font-size: 30px;
                    color: #000;
                  "
                  @click.stop="clearImg"
                />
              </div>
              <i v-else class="el-icon-plus" />
            </el-upload>
            <p style="margin-left: 0; color: grey; font-size: 12px">
              上传jpg或png,尺寸226*88像素
              <el-button type="text" @click="viewingCases()"
                >查看案例</el-button
              >
            </p>
          </div>
        </el-form-item>
        <el-form-item label="关于我们：">
          <el-input
            type="textarea"
            maxlength="500"
            show-word-limit
            style="width: 300px"
            :rows="8"
            :disabled="requireStatus"
            placeholder="请输入内容"
            v-model="userInfo.about"
            size="mini"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系方式（手机号码）：" prop="mobile">
          <el-input
            v-model="userInfo.mobile"
            :disabled="requireStatus"
            placeholder="请输入联系方式"
            size="mini"
            style="margin-right: 20px"
          ></el-input>
          注意：默认调取管理员注册手机号码，可修改
        </el-form-item>
        <el-form-item label="微信号：" prop="wechat">
          <el-input
            v-model="userInfo.wechat"
            :disabled="requireStatus"
            placeholder="请输入微信号"
            size="mini"
          ></el-input>
        </el-form-item>
        <div class="gap"></div>
        <el-form-item label="微信二维码上传：">
          <div v-if="requireStatus">
            <el-image
              v-if="userInfo.wechat_code"
              style="width: 226px; height: 88px"
              fit="contain"
              :src="userInfo.wechat_code"
              :preview-src-list="[userInfo.wechat_code]"
            />
          </div>
          <div v-else>
            <el-upload
              action="#"
              class="avatar-uploader2"
              accept="gif,bmp,jpg,jpeg,png"
              :show-file-list="false"
              :multiple="false"
              :auto-upload="false"
              :on-change="
                (file, fileList) => {
                  handleAvatarSuccess(file, fileList, 'wechat_code');
                }
              "
              :disabled="requireStatus"
            >
              <div v-if="userInfo.wechat_code" style="position: relative">
                <img :src="userInfo.wechat_code" />
                <i
                  class="el-icon-error"
                  style="
                    position: absolute;
                    right: -15px;
                    top: -15px;
                    font-size: 30px;
                    color: #000;
                  "
                  @click.stop="clearImg2"
                />
              </div>
              <i v-else class="el-icon-plus" />
            </el-upload>
            <p style="margin-left: 0; color: grey; font-size: 12px">
              上传jpg或png,尺寸88*88像素
            </p>
          </div>
        </el-form-item>

        <el-form-item label="机构地址：">
          <el-input
            type="textarea"
            maxlength="100"
            show-word-limit
            style="width: 300px"
            :rows="8"
            :disabled="requireStatus"
            placeholder="请输入内容"
            v-model="userInfo.address"
            size="mini"
          ></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button
          v-if="checkCool"
          type="primary"
          class="checkCool"
          @click="editAgain"
        >
          <span v-if="checkStatus == 1">取消审核，</span>
          {{ checkCool }}
        </el-button>
        <div>
          <el-button
            v-if="checkStatus == 0"
            type="primary"
            @click="editCode('codeInfoForm')"
            size="mini"
            >{{ btNoti }}</el-button
          >
          <p v-else class="checkCool2">{{ btNoti }}</p>
        </div>
        <!-- <el-button @click="resetCodeShow = false" size="mini">取 消</el-button> -->
      </div>
    </div>

    <el-dialog
      title="审核结果"
      :visible.sync="errShow"
      class="formDialog"
      width="500px"
    >
      <h4 style="color: red">审核信息未通过</h4>
      <h4>未通过原因：{{ errMsg }}</h4>
    </el-dialog>

    <el-dialog :visible.sync="viewingVisible" width="500px">
      <div>
        <iframe
          :src="firstSrc"
          :width="firstWidth"
          :height="firstHeight"
          frameborder="0"
          allowfullscreen
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import commonApi from "@/api/common.js";
import OSS from "ali-oss";
export default {
  name: "institutionsOption",
  data() {
    return {
      isCheck: 0, //审核状态 0 未审核 1 审核中 2 审核通过 3 审核拒绝
      userInfo: {
        is_show: 1,
        is_share_show: 0,
        name: "",
        logo: "",
        about: "",
        mobile: "",
        wechat: "",
        share_title: "",
        share_content: "",
        check_id: "",
      },
      userRules: {
        mobile: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
        ],
        wechat: [{ required: true, message: "请输入微信号", trigger: "blur" }],
      },
      loading: false,
      // OSS阿里云上传配置信息
      keysArr: {
        AccessKeySecret: "axa8TvZsnh7TPt84P9h3ExcBKNH8H2",
        AccessKeyId: "LTAI5tKbL1F137o429peV8bY",
        UrlHeader: "https://img2.meite.com/",
        Expiration: "",
        SecurityToken: "",
      },
      uploadFilesName: "",
      uploadfile: [],
      checkInfo: {},
      checkStatus: 0,
      editAgainShow: false,
      errShow: false,
      errMsg: "",
      checkId: 0,
      checkStatusAbout: 0,
      viewingVisible: false,
      firstSrc: "",
      firstWidth: "100%",
      firstHeight: "500px",
    };
  },
  created() {
    console.log(process.env.NODE_ENV);
    if (process.env.NODE_ENV === "development") {
      this.firstSrc =
        "http://testLavaMobile.qbting.com/testtask/#/web?key=beikaotonglogosm&apptype=beikaotong";
    } else {
      this.firstSrc =
        "http://qmb.meite.com/task/#/web?key=beikaotonglogosm&apptype=beikaotong";
    }

    this.queryTable().then((res) => {
      let _check = JSON.parse(
        JSON.stringify(this.$store.state.user.userInfo.check)
      );
      let _normalInfo = JSON.parse(
        JSON.stringify(this.$store.state.user.userInfo.group)
      );
      //  _check);
      if (_check && Object.keys(_check).length) {
        this.checkStatusAbout = _check.status;
        if (_check.status) {
          this.userInfo = _check.content;
        } else {
          this.userInfo = _normalInfo;
        }

        this.checkId = _check.id;
        this.checkStatus = _check.status;
        if (_check.status == 3) {
          this.errShow = true;
          this.errMsg = _check.reason;
        } else if (_check.status == 2) {
          let flagStatus = window.sessionStorage.getItem("flagStatus");
          if (Number(flagStatus)) {
            // this.$confirm('审核通过！', '提示', {
            //     confirmButtonText: '关闭',
            //     // cancelButtonText: '关闭',
            //     type: 'warning'
            // })
            this.$alert("审核通过！", "提示", {
              confirmButtonText: "关闭",
              callback: (action) => {},
            });
            window.sessionStorage.setItem("flagStatus", 0);
          }
        }
      } else {
        this.userInfo = _normalInfo;
        this.checkStatus = 0;
      }
      if (this.checkStatus) {
        window.localStorage.setItem("isSave", 1);
      } else {
        window.localStorage.setItem("isSave", 0);
      }
    });
  },
  watch: {
    userInfo: {
      handler: function (newVal) {
        let _obj = JSON.parse(window.localStorage.getItem("userInfo"));
        //  _obj);
        if (this.checkId && _obj && this.checkStatusAbout) {
          this.$store.state.user.userInfo.check.content = newVal;
          _obj.check.content = newVal;
          //  'obj改变了')
        } else {
          this.$store.state.user.userInfo.group = newVal;
          _obj.group = newVal;
        }
        //  '___obj___',_obj);
        window.localStorage.setItem("userInfo", JSON.stringify(_obj));
      },
      deep: true,
    },
  },
  computed: {
    notice() {
      let _noti = this.userInfo.is_show;
      return _noti
        ? "开启后APP相关页面将显示以下机构内容信息"
        : "关闭后APP相关页面将不显示以下机构内容信息";
    },
    checkCool() {
      let _noti = "";
      switch (this.checkStatus) {
        case 0:
          _noti = "";
          break;
        case 1:
          _noti = "重新编辑";
          break;
        case 2:
          _noti = "重新编辑";
          break;
        case 3:
          _noti = "重新编辑";
          break;
      }
      return _noti;
    },
    btNoti() {
      let _noti = "";
      switch (this.checkStatus) {
        case 0:
          _noti = "提交审核";
          break;
        case 1:
          _noti = "审核中";
          break;
        case 2:
          _noti = "审核通过";
          break;
        case 3:
          _noti = "审核不通过";
          break;
      }
      return _noti;
    },
    requireStatus() {
      //  this.checkStatus,111,this.editAgainShow);
      if (!this.checkStatus || this.editAgainShow) {
        return false;
      } else {
        return true;
      }
    },
  },
  methods: {
    clearImg2() {
      this.userInfo.wechat_code = "";
      this.$forceUpdate(); //刷新
    },
    clearImg() {
      this.userInfo.logo = "";
      this.$forceUpdate(); //刷新
    },
    viewingCases() {
      this.viewingVisible = true;
    },
    //重新编辑
    async editAgain(type) {
      const res1 = await commonApi.accountsUnCheck({ check_id: this.checkId });
      if (res1.code == 200) {
        this.editAgainShow = true;
        window.localStorage.setItem("isSave", 1);
        this.queryTable().then((res) => {
          let _status = this.$store.state.user.userInfo.check.status;
          console.log("_status", _status);
          if (_status) {
            this.userInfo = JSON.parse(
              JSON.stringify(this.$store.state.user.userInfo.check.content)
            );
          } else {
            this.userInfo = JSON.parse(
              JSON.stringify(this.$store.state.user.userInfo.group)
            );
          }

          window.localStorage.setItem("isSave", 0);
          this.checkStatus = 0;
        });
        // this.userInfo = JSON.parse(JSON.stringify(this.$store.state.user.userInfo.check.content))
        if (!type) {
          this.$message.success("已取消审核");
        }
      }
    },
    // 获取年月Fn
    getDate() {
      const date = new Date();
      const year = String(date.getFullYear());
      const month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      return year + month;
    },
    // 获取随机文件名称
    getFileName(length) {
      const data = [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "g",
        "h",
        "i",
        "j",
        "k",
        "l",
        "m",
        "n",
        "o",
        "p",
        "q",
        "r",
        "s",
        "t",
        "u",
        "v",
        "w",
        "x",
        "y",
        "z",
      ];
      let nums = "";
      for (let i = 0; i < length; i++) {
        const r = parseInt(Math.random() * 61, 10);
        nums += data[r];
      }
      return nums;
    },
    // 处理广告图片的上传
    handleAvatarSuccess(res, file, key) {
      // this.coverAdUpstatus = true;
      let limitSize = res.size / 1024 / 1024;
      let type = res.raw.type;
      let upType = res.raw.type.split("/").pop();
      if (
        (limitSize < 2 && type == "image/jpeg") ||
        type == "image/png" ||
        type == "image/jpg"
      ) {
        let name = `questions/${this.getDate()}/${this.getFileName(
          16
        )}.${upType}`;
        //  1111);
        this.FileUpload("ad", name, res.raw, key);
      } else {
        this.$message({
          type: "error",
          showClose: true,
          message: "只能上传jpeg、jpg或png文件，且大小不超过2M",
        });
        this.coverAdUpstatus = false;
      }
    },
    // 图片上传
    FileUpload(type, name, file, key) {
      var client = new OSS({
        region: "oss-cn-hangzhou",
        // endpoint: 'oss-cn-hangzhou',
        accessKeyId: this.keysArr.AccessKeyId,
        accessKeySecret: this.keysArr.AccessKeySecret,
        // bucket: 'meitetest',
        bucket: "meitetest",
      });
      client
        .put(name, file)
        .then((res) => {
          this.uploadfile = [
            {
              url: `${this.keysArr.UrlHeader}${res.name}`,
              name: res.name,
            },
          ];
          if (key == "logo") {
            this.userInfo.logo = this.uploadfile[0].url;
          } else if (key == "wechat_code") {
            this.userInfo.wechat_code = this.uploadfile[0].url;
          }
          this.$message({
            message: "上传成功!",
            type: "success",
            showClose: true,
          });
        })
        .catch((err) => {
          //  err);
        });
    },
    editCode(formName) {
      // if()
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          if (this.checkStatus) {
            return;
            // const res1 = await commonApi.accountsUnCheck({check_id:this.checkId})
            // if(res1.code == 200){
            //     this.$message.success("已取消审核")
            //     this.editAgainShow = true
            //     this.userInfo = JSON.parse(JSON.stringify(this.$store.state.user.userInfo.group))
            //     await this.queryTable()
            //     this.checkId = this.$store.state.user.userInfo.check.id
            //     this.checkStatus = this.$store.state.user.userInfo.check.status
            //     this.editAgainShow = false
            //     this.userInfo = JSON.parse(JSON.stringify(this.$store.state.user.userInfo.check.content))
            //     return
            // }
          }
          let _obj = {};
          Object.assign(_obj, this.userInfo);
          if (this.checkId) {
            Object.assign(_obj, { check_id: this.checkId });
          }
          const res = await commonApi.accountsCheck(_obj);
          if (res.code == 200) {
            this.$message.success("后台审核人员通过后，可在APP上显示");
            this.resetCodeShow = false;
            window.localStorage.setItem("isSave", 1);
            window.sessionStorage.setItem("flagStatus", 1);
            this.queryTable().then((res2) => {
              //   console.log("about1---", 22);
              this.checkId = this.$store.state.user.userInfo.check.id;
              this.checkStatus = this.$store.state.user.userInfo.check.status;
              this.editAgainShow = false;
              if (this.checkStatus) {
                this.userInfo = JSON.parse(
                  JSON.stringify(this.$store.state.user.userInfo.check.content)
                );
              } else {
                this.userInfo = JSON.parse(
                  JSON.stringify(this.$store.state.user.userInfo.group)
                );
              }
            });
          } else {
            this.$message.error(res.message);
          }
        } else {
          //  'error submit!!');
          return false;
        }
      });
    },
    async queryTable() {
      const userInfoData = await commonApi.tobMe();
      let _info = userInfoData.data;
      if (userInfoData.data.password) {
        delete _info.password;
      }
      const isSave = window.localStorage.getItem("isSave");
      if (userInfoData.code == 200) {
        //  '~~isSave---',~~isSave);
        if (~~isSave) {
          //  'isSave',isSave);
          //   console.log("about1---", 111);
          this.$store.commit("user/SET_USER_INFO", _info);
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.el-form {
  min-width: 1200px;
}
.basicStyle {
  overflow: auto;
  h1 {
    margin: 10px 0 20px 0;
  }
  /deep/ .el-input,
  .el-textarea {
    width: 300px;
  }
  .dialog-footer {
    text-align: center;
    margin: 20px 0;
  }
  .notice {
    font-size: 12px;
    color: #846ffd;
    margin-left: 200px;
  }
}
.checkCool {
  margin-bottom: 15px;
  font-size: 14px;
  color: #fff;
  cursor: pointer;
}
.checkCool2 {
  margin-bottom: 15px;
  font-size: 14px;
  color: #606061;
  cursor: pointer;
}

h4 {
  margin-bottom: 15px;
  line-height: 30px;
}

/deep/ .el-radio__input.is-checked + .el-radio__label {
  color: #846ffd;
}
/deep/ .el-input.is-disabled .el-input__inner {
  background-color: #fff;
}
/deep/ .el-textarea.is-disabled .el-textarea__inner {
  background-color: #fff;
}

.popoverClass {
  padding-top: 10px;
  margin-right: 50px;
  p {
    text-align: center;
  }
  /deep/ .el-button {
    border: none;
    padding: 0;
    background: none;
  }
  /deep/ .el-button:focus,
  .el-button:hover {
    background: none;
  }
  img {
    width: 20px;
    height: 20px;
    // margin: 0 50px 0 10px;
    margin-left: 10px;
  }
}
.extraItem {
  margin-left: 0;
  /deep/ .el-form-item__content {
    margin-left: 0 !important;
  }
}
/deep/.extraDiv {
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  padding: 0 12px 0 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
/deep/.el-popover p {
  text-align: left;
  width: 300px;
  padding: 0 10px;
}
/deep/.avatar-uploader2 .el-upload {
  width: 88px !important;
  height: 88px !important;
  align-items: center;
  display: flex;
  justify-content: center;
  border: 1px solid #ddd;
  border-radius: 5px;
}
/deep/.avatar-uploader2 img {
  width: 88px !important;
  height: 88px !important;
  line-height: 88px;
}
.checkCool {
}
.bg_box {
  background-color: #fff;
  border-radius: 8px;
  padding: 20px;
}

.questionIcon {
  width: 19px;
  height: 19px;
  background-image: url("../../assets/new/questionIcon_a1.png");
  background-size: 19px 19px;
  margin-left: 10px;
}
.questionIcon:hover {
  background-image: url("../../assets/new/questionIcon_a2.png");
  background-size: 19px 19px;
}

/deep/.avatar-uploader .el-upload {
  overflow: unset;
}
</style>
